import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Drawer, IconButton, Grid } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";
import { useMenu } from "./MenuContext";
import MenuItem from "./MenuItem";
import UserProfileMenu from "./UserProfileMenu";
import MenuBackground from "./svg/bg-menu-yellow.svg";
import { colors } from "../../theme";
import { useAuth } from "../../firebase/AuthProvider";
import UnauthenticatedMenu from "./UnauthenticatedMenu";
import LogoYfca from "./svg/logo-yfca.svg";
import LogoActadapt from "./svg/logo-actadapt.png";
import LogoGca from "./svg/logo-gca.svg";

const drawerWidth = 370;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  menuHeader: {
    background: `url(${MenuBackground})`,
    height: "179px",
  },
  gridImage: {
    margin: "0 auto",
    marginTop: "30px",
  }
}));

export default function Menu() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { open, closeMenu } = useMenu();
  const { isSignedIn } = useAuth();

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
      onClose={closeMenu}
    >
      <div className={classes.menuHeader}>
        <Grid container direction="column">
          <Grid item style={{ textAlign: "right" }}>
            <IconButton onClick={closeMenu}>
              <CloseIcon style={{ color: colors.MENU_CLOSE_ICON }} />
            </IconButton>
          </Grid>
          <Grid item>
            {isSignedIn ? <UserProfileMenu /> : <UnauthenticatedMenu />}
          </Grid>
        </Grid>
      </div>
      <Grid item style={{ paddingTop: "40px" }}>
        <MenuItem to="/">{t("menu.allstatements")}</MenuItem>

        {isSignedIn && <MenuItem to="/profile">{t("menu.profile")}</MenuItem>}

        <MenuItem to="/frequently-asked-questions">
          {t("menu.frequentlyaskedquestions")}
        </MenuItem>

        <MenuItem to="/contact">{t("menu.contact")}</MenuItem>

        <MenuItem to="/terms-and-conditions">
          {t("menu.termsandconditions")}
        </MenuItem>

        <MenuItem to="/code-of-conduct">
          {t("menu.codeofconduct")}
        </MenuItem>
        <MenuItem to="/settings">
          {t("menu.settings")}
        </MenuItem>

        <Grid container item >
          <Grid container item xs={12}>
            <img src={LogoYfca} style={{width: "60px"}} className={classes.gridImage} alt="logo"/>
          </Grid>
          <Grid container item xs={12}>
            <img src={LogoGca} className={classes.gridImage} style={{width: "120px"}} alt="logo"/>
          </Grid>
          <Grid container item xs={12}>
            <img src={LogoActadapt} style={{width: "auto", height: "35px"}} className={classes.gridImage} alt="logo"/>
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
}
